import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href", "disabled"]
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = ["src"]

import { ArrowRightIcon, CheckIcon } from '@heroicons/vue/20/solid';
import { computed } from 'vue';
import { GiveawayRequirementType } from '@manifoldxyz/redeem-client';
import XIcon from '@/assets/images/x-logo.svg';
import { usePatchSignup } from '@/composables/signup';
import { RequirementWithCollectorData } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TwitterRequirement',
  props: {
    requirement: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const complete = computed(() => {
  return !!props.requirement.complete;
});

const { patch } = usePatchSignup({
  onSuccess: () => {
    // console.log('email updated');
  },
  onError: (_error: any) => {
    // console.log('Error updating email', error);
  },
});

const intentLink = computed(() => {
  const requirementType = props.requirement.type;
  const link = props.requirement.link;
  if (!link) {
    return '';
  }

  const path = link.split('/');
  const username = path[3];
  if (path.length < 4) {
    return '';
  }
  if (requirementType === GiveawayRequirementType.TWITTER_FOLLOW) {
    return `https://x.com/intent/follow?original_referer=${encodeURIComponent(
      window.location.href
    )}&region=follow_link&screen_name=${username}`;
  }
  if (path.length < 6) {
    return '';
  }
  const tweetId = path[5];
  const intent =
    props.requirement.type === GiveawayRequirementType.TWITTER_LIKE ? 'like' : 'retweet';
  return `https://x.com/intent/${intent}?original_referer=${encodeURIComponent(
    window.location.href
  )}&region=follow_link&screen_name=${username}&tweet_id=${tweetId}`;
});

const username = computed(() => {
  const link = props.requirement.link;
  if (!link) {
    return;
  }

  const path = link.split('/');
  return path[3];
});

const requirementTypes = computed(() => {
  return {
    [GiveawayRequirementType.TWITTER_FOLLOW]: {
      text: `Follow ${username.value || 'user'} on X`,
    },
    [GiveawayRequirementType.TWITTER_LIKE]: {
      text: 'Like this post on X',
    },
    [GiveawayRequirementType.TWITTER_RETWEET]: {
      text: 'Retweet this post on X',
    },
  };
});

function onClick() {
  patch({
    userData: { clicked: true },
    index: props.requirement.index,
    type: props.requirement.type,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: intentLink.value,
    class: _normalizeClass(`requirement ${_ctx.disabled ? 'disabled' : ''} ${complete.value ? 'completed' : ''}`),
    target: "_blank",
    disabled: _ctx.disabled,
    onClick: onClick
  }, [
    _createElementVNode("div", _hoisted_2, [
      (!complete.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "icon-x",
            src: _unref(XIcon),
            alt: "requirement"
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createBlock(_unref(CheckIcon), {
            key: 1,
            class: "icon-complete"
          })),
      _createElementVNode("span", null, _toDisplayString(requirementTypes.value[props.requirement.type]?.text), 1)
    ]),
    (!complete.value)
      ? (_openBlock(), _createBlock(_unref(ArrowRightIcon), {
          key: 0,
          class: "arrow"
        }))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})